import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';

//Projects
import ReactFileReader from 'react-file-reader';
import parseSRT from 'parse-srt';
import {
  setPlayerEditingSRTData,
  setTableData,
  setVideoFPS,
  AddDetialJsonData,
} from '../../actions/transOperationActions';
import { addTenRow } from '../../actions/editTableActions';
import { Button } from 'react-bootstrap';

import { copyToSource } from '../../actions/transOperationActions';
import { Divider, Header, Icon } from 'semantic-ui-react';
import ApiUtils from '../../helper/ApiUtils';
import DataObj from '../../class/DataObj';
import TimeUtils from '../../helper/TimeUtils';
import StringUtils from '../../helper/StringUtils';
import WaveformView from '../drogable/WaveformView';
import SubTitleUtils from '../../helper/SubTitleUtils';

class ImportView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jsonSubs: '',
      videoFps: 23.98,
    };

    this.handleFiles = this.handleFiles.bind(this);
    this.handleFiles_flash_xml = this.handleFiles_flash_xml.bind(this);
    this.handleFiles_MicroDVD = this.handleFiles_MicroDVD.bind(this);

    this.handleSourceFiles = this.handleSourceFiles.bind(this);
    this.setFps = this.setFps.bind(this);
    this.send_setTableData = this.send_setTableData.bind(this);
    this.getFileExtension1 = this.getFileExtension1.bind(this);
    //this.parseSRT = this.parseSRT.bind(this);

    this.ProcessSRT = this.ProcessSRT.bind(this);
    this.ProcessSCC = this.ProcessSCC.bind(this);
    this.ProcessVTT = this.ProcessVTT.bind(this);
    this.ProcessXML_FLASH = this.ProcessXML_FLASH.bind(this);
    this.ProcessSSA = this.ProcessSSA.bind(this);
    this.ProcessQT = this.ProcessQT.bind(this);
    this.ProcessXML_Time = this.ProcessXML_Time.bind(this);
    this.ProcessTTML_Time = this.ProcessTTML_Time.bind(this);
    this.ProcessDFXP = this.ProcessDFXP.bind(this);

    this.ProcessMicroDVD = this.ProcessMicroDVD.bind(this);
    this.ProcessSubViewer = this.ProcessSubViewer.bind(this);

    this.ProcessCap = this.ProcessCap.bind(this);

    this.uploadDataObjArray = this.uploadDataObjArray.bind(this);
  }

  setFps(fps) {
    this.setState({ videoFps: fps });

    this.props.setVideoFPS(fps);
  }

  getFileExtension1(filename) {
    return /[.]/.exec(filename) ? /[^.]+$/.exec(filename)[0] : undefined;
  }

  send_setTableData(jsonSubs) {
    this.props.importAct(jsonSubs);
  }

  //上傳檔案
  async uploadDataObjArray(newDataArray) {
    //建立的新資料
    // let newDataObjArray = new DataObjArray();
    // newDataObjArray.setImportInitArray(newDataArray);
    // newDataObjArray.addEmpRow();

    // 加一個空白
    const emp = new DataObj();
    emp.setTSubType(WaveformView.projectSubType);
    newDataArray.push(emp);

    this.setState({ jsonSubs: newDataArray });
    //return jsonSubs;

    //確認資料index 跟專案資料
    let projectIndex = parseInt(this.props.match.params.tIndex, 10);
    const projectListDataString = localStorage.getItem('projectListData');

    //取得本地資料
    const projectListData = JSON.parse(projectListDataString);
    const projectData = projectListData[projectIndex];
    const projectDetial = projectData.projectDetial;

    const { user } = this.props.auth;
    const email = user['email'];

    //新增
    // await this.props.AddDetialJsonData({
    //   tProjectDetialId: projectDetial.fId,
    //   jsonstring: newDataObjArray.getContent(),
    //   email: email,
    // });
    await this.props.AddDetialJsonData({
      tProjectDetialId: projectDetial.fId,
      jsonstring: newDataArray,
      email: email,
    });

    window.location.reload();
  }

  ProcessSRT(reader) {
    /**
     * 自定義匯入
     * */
    let jsonSubs = parseSRT(reader.result);

    let newDataArray = [];
    jsonSubs.map((data) => {
      const { start, end, text } = data;

      let dataObj = new DataObj();
      dataObj.setInOut('In', start);
      dataObj.setInOut('Out', end);
      dataObj.setSubtitleCaption(text);
      newDataArray.push(dataObj);
    });

    //抬字幕處理
    let an8_Index_Array = this.get_An8_Index_Array(reader.result);
    an8_Index_Array.map((index) => {
      const dataObj = newDataArray[index];

      console.log(dataObj);
      dataObj.Position = 1;
    });

    //處理完上傳
    this.uploadDataObjArray(newDataArray);
  }

  lastNonEmptyLine(linesArray) {
    var idx = linesArray.length - 1;

    while (idx >= 0 && !linesArray[idx]) {
      idx--;
    }

    return idx;
  }

  nextNonEmptyLine(linesArray, position) {
    var idx = position;

    while (!linesArray[idx]) {
      idx++;
    }

    return idx;
  }

  get_An8_Index_Array(data) {
    var an8_Index_Array = [];

    //var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var subs = [];
    var lines = data.split(/(?:\r\n|\r|\n)/gm);
    var endIdx = this.lastNonEmptyLine(lines) + 1;
    var idx = 0;
    var time = void 0;
    var text = void 0;
    var sub = void 0;

    for (var i = 0; i < endIdx; i++) {
      sub = {};
      text = [];

      i = this.nextNonEmptyLine(lines, i);
      sub.id = parseInt(lines[i++], 10);

      time = lines[i++].split(/[\t ]*-->[\t ]*/);

      idx = time[1].indexOf(' ');
      if (idx !== -1) {
        time[1] = time[1].substr(0, idx);
      }
      while (i < endIdx && lines[i]) {
        text.push(lines[i++]);
      }

      console.log(text);

      for (var k = 0; k < text.length; k++) {
        const targetString = text[k];
        if (targetString.includes('an8}') === true) {
          const targetIndex = parseInt(sub.id) - 1;
          an8_Index_Array.push(targetIndex);
          break;
        }
      }
    }

    return an8_Index_Array;
  }

  async ProcessSCC(reader) {
    const { read_data, toJSON } = require('../../helper/NodeCaptions/lib/scc');
    const { generate } = require('../../helper/NodeCaptions/lib/srt');

    let newDataArray = [];
    await read_data(reader.result, {}, function (err, data) {
      //處理SCC
      const dataJson = toJSON(data);
      const srtJson = generate(dataJson);

      // //轉到SRT
      let jsonSubs = parseSRT(srtJson);

      jsonSubs.map((data) => {
        const { start, end, text } = data;

        let dataObj = new DataObj();
        dataObj.setInOut('In', start);
        dataObj.setInOut('Out', end);
        dataObj.setSubtitleCaption(text);
        newDataArray.push(dataObj);
      });
    });

    //處理完上傳
    this.uploadDataObjArray(newDataArray);
  }

  async ProcessSMI(reader) {
    const { generate } = require('../../helper/NodeCaptions/lib/smpte_tt');

    let data = generate(reader.result);

    console.log(data);
  }

  ProcessVTT(reader) {
    try {
      //使用npm node-webvtt
      const { parse } = require('../../helper/VTT/parser');
      const parsed = parse(reader.result);

      //格式
      // {"identifier":"","start":0.51,"end":6.03,"text":"昨日之歌","styles":""}

      let newDataArray = [];
      const DataArray = parsed['cues'];
      DataArray.map((data) => {
        const { start, end, text } = data;

        let dataObj = new DataObj();

        //抬字幕處理
        // console.log('抬字幕處理');
        //抬字幕處理
        let subtitle = text;
        if (subtitle.includes('an8}')) {
          subtitle = subtitle.replace('{\\an8}', '');
          dataObj.Position = 1;
        }
        dataObj.setSubtitleCaption(subtitle);

        dataObj.setInOut('In', parseFloat(start));
        dataObj.setInOut('Out', parseFloat(end));
        newDataArray.push(dataObj);
      });

      //處理完上傳
      this.uploadDataObjArray(newDataArray);
    } catch (e) {
      // return 0;
      console.warn(e);
    }
  }

  ProcessSSA(reader, ExtensionName) {
    var subsrt = require('subsrt');

    //MicroDVD (.sub) content
    var sub = reader.result;

    var srt = subsrt.parse(sub, { format: ExtensionName, verbose: true });

    //格式
    // {"identifier":"","start":0.51,"end":6.03,"text":"昨日之歌","styles":""}

    let newDataArray = [];
    const DataArray = srt.filter((data) => data['type'] === 'caption');

    // console.log(srt)
    // console.log(JSON.stringify(DataArray))
    // return;

    /**
         * meta 與 Style
         * {
    "type": "meta",
    "data": {
      "Title": "phpZLM0nk",
      "ScriptType": "v4.00+",
      "Collisions": "Normal",
      "PlayDepth": "0"
    }
  },
         {
    "type": "style",
    "data": {
      "Name": "Default",
      "Fontname": "Arial",
      "Fontsize": "20",
      "PrimaryColour": "&H00FFFFFF",
      "SecondaryColour": "&H0300FFFF",
      "OutlineColour": "&H00000000",
      "BackColour": "&H02000000",
      "Bold": "0",
      "Italic": "0",
      "Underline": "0",
      "StrikeOut": "0",
      "ScaleX": "100",
      "ScaleY": "100",
      "Spacing": "0",
      "Angle": "0",
      "BorderStyle": "1",
      "Outline": "2",
      "Shadow": "1",
      "Alignment": "2",
      "MarginL": "10",
      "MarginR": "10",
      "MarginV": "10",
      "Encoding": "1"
    }
  },
         * */

    DataArray.map((data) => {
      const { start, end, text } = data;

      // content: "Go ahead, say something."
      // data:
      //     Effect: ""
      // End: "0:00:00.00"
      // MarginL: "0000"
      // MarginR: "0000"
      // MarginV: "0000"
      // Marked: "Marked=0"
      // Name: "NTP"
      // Start: "0:00:00.00"
      // Style: "DefaultVCD"
      // Text: "Go ahead, say something."
      // duration: 0
      // end: 0
      // start: 0
      // text: "Go ahead, say something."
      // type: "caption"
      //
      let dataObj = new DataObj();
      dataObj.setInOut('In', parseFloat(start) / 1000);
      dataObj.setInOut('Out', parseFloat(end) / 1000);
      dataObj.setSubtitleCaption(text);
      newDataArray.push(dataObj);
    });

    //處理完上傳
    this.uploadDataObjArray(newDataArray);
  }

  ProcessQT(reader, ExtensionName) {
    //MicroDVD (.sub) content
    var sub = reader.result;

    console.log(JSON.stringify(sub));

    return;

    // var srt = subsrt.parse(sub, {format:ExtensionName,verbose: true   });
    //
    //
    // //格式
    // // {"identifier":"","start":0.51,"end":6.03,"text":"昨日之歌","styles":""}
    //
    //
    // let newDataArray = [];
    // const DataArray = srt.filter(data=>data["type"]==='caption');
    //
    //
    // DataArray.map(data=>{
    //     const {start,end,text} = data;
    //
    //     let dataObj = new DataObj();
    //     dataObj.setInOut("In",parseFloat(start)/1000);
    //     dataObj.setInOut("Out",parseFloat(end)/1000);
    //     dataObj.setSubtitleCaption(text);
    //     newDataArray.push(dataObj);
    // });
    //
  }

  async ProcessXML_FLASH(reader) {
    let parseString = require('xml2js').parseString;
    let xml = reader.result;
    let xmlJson = {};
    await parseString(xml, function (err, result) {
      xmlJson = result;
    });

    const ttList = xmlJson.tt;
    const divList = ttList.div;

    let newDataArray = [];
    const DataArray = divList[0].p;
    DataArray.map((data) => {
      const { _, $ } = data;
      const { end, begin } = $;

      const newSubtitleCaption = _.replace('<sub>', '')
        .replace('</sub>', '')
        .replace('<br />', '\n');

      let dataObj = new DataObj();
      dataObj.setInOut(
        'In',
        TimeUtils.getTimestringFromTimecode(begin.replace('.', ','))
      );
      dataObj.setInOut(
        'Out',
        TimeUtils.getTimestringFromTimecode(end.replace('.', ','))
      );
      dataObj.setSubtitleCaption(newSubtitleCaption);
      newDataArray.push(dataObj);
    });

    //處理完上傳
    this.uploadDataObjArray(newDataArray);
  }

  async ProcessXML_Time(reader) {
    let parseString = require('xml2js').parseString;
    let xml = reader.result;
    let xmlJson = {};
    await parseString(xml, function (err, result) {
      xmlJson = result;
    });

    const ttList = xmlJson.tt;
    const headObj = ttList.head; //包含 metadata 與 styling
    const bodyObj = ttList.body;
    const { div } = bodyObj[0];

    let newDataArray = [];
    const DataArray = div[0].p;
    DataArray.map((data) => {
      const { _, $ } = data;
      const { end, begin } = $;

      let dataObj = new DataObj();
      dataObj.setInOut('In', parseFloat(begin.replace('s', '')));
      dataObj.setInOut('Out', parseFloat(end.replace('s', '')));
      dataObj.setSubtitleCaption(_);
      newDataArray.push(dataObj);
    });

    //處理完上傳
    this.uploadDataObjArray(newDataArray);
  }

  async ProcessTTML_Time(reader) {
    const tSubType = this.props.projectData.Project.tSubType;

    let parseString = require('xml2js').parseString;
    let xml = reader.result;
    let xmlJson = {};
    await parseString(xml, function (err, result) {
      xmlJson = result;
    });

    const videoFps = TimeUtils.getFPS();

    const ttList = xmlJson.tt;
    const bodyObj = ttList.body;
    const { div } = bodyObj[0];

    let newDataArray = [];
    const DataArray = div[0].p;
    DataArray.map((data) => {
      const { _, $ } = data;
      const { end, begin } = $;

      const begin_numberArray = begin.split(':');
      const end_numberArray = end.split(':');

      // 舊的進位方式
      // const begin_f =
      //   parseFloat(begin_numberArray[3]) === 0
      //     ? "00"
      //     : ((parseFloat(begin_numberArray[3]) / 100) * videoFps).toFixed();
      //     const end_f =
      //   parseFloat(end_numberArray[3]) === 0
      //     ? "00"
      //     : ((parseFloat(end_numberArray[3]) / 100) * videoFps).toFixed();

      // 不使用進位 直接用Timecode
      const begin_f = begin_numberArray[3];
      const end_f = end_numberArray[3];

      // 00:21:46:17
      let dataObj = new DataObj();
      dataObj.setTSubType(tSubType);
      dataObj.setInOut(
        'In',
        `${begin_numberArray[0]}:${begin_numberArray[1]}:${begin_numberArray[2]}.${begin_f}`
      );
      dataObj.setInOut(
        'Out',
        `${end_numberArray[0]}:${end_numberArray[1]}:${end_numberArray[2]}.${end_f}`
      );
      dataObj.setSubtitleCaption(_);
      newDataArray.push(dataObj);
    });

    //處理完上傳
    this.uploadDataObjArray(newDataArray);
  }

  async ProcessDFXP(reader) {
    let parseString = require('xml2js').parseString;
    let xml = reader.result;
    let xmlJson = {};
    await parseString(xml, function (err, result) {
      xmlJson = result;
    });

    const videoFps = TimeUtils.getFPS();

    const ttList = xmlJson.tt;
    const headObj = ttList.head; //包含 metadata 與 styling
    const bodyObj = ttList.body;
    const { div } = bodyObj[0];

    //
    let newDataArray = [];
    const DataArray = div[0].p;
    DataArray.map((data) => {
      let dataObj = new DataObj();
      dataObj.setTSubType(WaveformView.projectSubType);

      const { _, $ } = data;
      const { end, begin } = $;

      let beginArray = begin.split(':');
      let endArray = end.split(':');

      //抬字幕處理
      let subtitle = _;
      if (subtitle) {
        // 一般字幕處理
        setSubTitle(subtitle);
      } else {

        let specSubtitle = "";

        // // 特殊字幕格式
        const { span } = data; 
        span.map((obj, index) => {
          const { _, $ } = obj;
          const subString = _;
          const styleName = $['tts:fontStyle'];
          if (styleName === 'italic') {
            // 加入斜體標籤
            specSubtitle += SubTitleUtils.setItalicStyle(subString, true);

            // 如果不是最後一個 要加入 \n
            if (index !== (span.length - 1)) {
              specSubtitle += '\n';
            } 
          } 
        });
        setSubTitle(specSubtitle); 
      }

      /**
       * 解析 p 裡面的物件
       */
      function parseTagP(_data) {}

      /**
       * 把最終的文字物件帶入 dataObj
       * @param {*} _subtitle
       */
      function setSubTitle(_subtitle) {
        if (_subtitle.includes('an8}')) {
          // 抬 1
          dataObj.Position = 1;
          dataObj.setSubtitleCaption(_subtitle.replace('{\\an8}', ''));
        } else {
          dataObj.setSubtitleCaption(_subtitle);
        }
      }

      // 處理 InTC OutTC
      if (beginArray.length === 4) {
        // $: {style: "style.default", region: "region.after.center", begin: "01:25:39:13", end: "01:25:40:17"}
        // _: "Oh, yeah."
        // __proto__: Object
        dataObj.setInOut(
          'In',
          `${beginArray[0]}:${beginArray[1]}:${beginArray[2]}.${beginArray[3]}`
        );
        dataObj.setInOut(
          'Out',
          `${endArray[0]}:${endArray[1]}:${endArray[2]}.${endArray[3]}`
        );
        newDataArray.push(dataObj);
      } else {
        // begin:'00:00:38.640'
        // end:'00:00:40.640'
        // region:
        // 'bottom'
        // style:
        // 'AmazonDefaultStyle'
        // xml:id:
        // 'p1'

        const begingSecondFrame = beginArray[2].split('.');
        const endSecondFrame = endArray[2].split('.');

        const begingFrame = Math.round(
          (parseFloat(begingSecondFrame[1]) / 1000) * videoFps
        );
        const endFrame = Math.round(
          (parseFloat(endSecondFrame[1]) / 1000) * videoFps
        );

        dataObj.setInOut(
          'In',
          `${beginArray[0]}:${beginArray[1]}:${begingSecondFrame[0]}.${
            parseInt(begingFrame, 10) < 10
              ? `0${parseInt(begingFrame, 10)}`
              : parseInt(begingFrame, 10)
          }`
        );
        dataObj.setInOut(
          'Out',
          `${endArray[0]}:${endArray[1]}:${endSecondFrame[0]}.${
            parseInt(endFrame, 10) < 10
              ? `0${parseInt(endFrame, 10)}`
              : parseInt(endFrame, 10)
          }`
        );
        newDataArray.push(dataObj);
      }
    });

    //處理完上傳
    this.uploadDataObjArray(newDataArray);
  }

  handleFiles_flash_xml(files) {
    var file = files[0];
    var reader = new FileReader();

    //檔名
    let fileName = file.name;

    let event = new Promise((resolve, reject) => {
      reader.onload = async () => {
        this.ProcessXML_FLASH(reader);
      };
    });
    reader.readAsText(file);
  }
  handleFiles_MicroDVD(files) {
    var file = files[0];
    var reader = new FileReader();

    //檔名
    let fileName = file.name;

    let event = new Promise((resolve, reject) => {
      reader.onload = async () => {
        this.ProcessMicroDVD(reader);
      };
    });
    reader.readAsText(file);
  }

  async ProcessMicroDVD(reader) {
    let videoFps = TimeUtils.getFPS();

    var subsrt = require('subsrt');

    //MicroDVD (.sub) content
    var sub = reader.result;

    var srt = subsrt.parse(sub, {
      format: 'sub',
      verbose: true,
      fps: videoFps,
    });

    let newDataArray = [];
    srt.map((data) => {
      const { frame, content } = data;
      const { start, end } = frame;

      let dataObj = new DataObj();
      dataObj.setInOut('In', start / videoFps);
      dataObj.setInOut('Out', end / videoFps);
      dataObj.setSubtitleCaption(content);
      newDataArray.push(dataObj);
    });

    //處理完上傳
    this.uploadDataObjArray(newDataArray);
  }

  async ProcessCap(reader) {
    // console.log(reader.result)

    // console.log(JSON.stringify(reader.result))

    //標題
    //Lambda字幕V4 DF1+1 SCENE\"和文標準\"\n\n

    //內文
    //1\t00000221/00000702\t牠們是可愛的卡瓦動物\n

    //拆分\n\n　標題與內文
    const all = `${reader.result}`.split('\n\n');

    const content = all[1];
    //console.log(JSON.stringify(content))
    // content.map(data=>{
    //     console.log(JSON.stringify(data))
    // });

    //
    // var subsrt = require('subsrt');
    //
    // //MicroDVD (.sub) content
    // var sub = reader.result;
    //
    // var srt = subsrt.parse(sub, {format:'sub',verbose: true , fps:videoFps });
    //
    // let newDataArray = [];
    // srt.map(data=>{
    //     const {frame,content} = data;
    //     const {start,end} = frame;
    //
    //     let dataObj = new DataObj();
    //     dataObj.setInOut("In",start/videoFps);
    //     dataObj.setInOut("Out",end/videoFps);
    //     dataObj.setSubtitleCaption(content);
    //     newDataArray.push(dataObj);
    // });
    //
    //
    // //處理完上傳
    // this.uploadDataObjArray(newDataArray);
  }

  async ProcessSubViewer(reader) {
    let subsrt = require('subsrt');

    //MicroDVD (.sub) content
    let sub = reader.result;

    let srt = subsrt.parse(sub, { format: 'sbv', verbose: false });

    if (srt.length === 0) {
      //有前置資訊

      let dataArray = sub.split('\r\n');

      let newsub = '';

      dataArray.map((data, index) => {
        if (index > 11) {
          let newSubtitleCaption = data.replace(/\n\n/g, '\r\n\r\n');

          newsub = `${newsub}` + newSubtitleCaption;
        }
      });
      srt = subsrt.parse(newsub, { format: 'sbv', verbose: false });
    }

    let newDataArray = [];
    srt.map((data) => {
      const { start, end, content } = data;

      //秒數處理
      // let newstart = Math.round(start/1000) + (start%1000)*10/1000;
      // let newend = Math.round(end/1000) + (end%1000)*10/1000;

      let dataObj = new DataObj();
      dataObj.setInOut('In', start / 1000);
      dataObj.setInOut('Out', end / 1000);
      dataObj.setSubtitleCaption(content);
      newDataArray.push(dataObj);
    });

    //處理完上傳
    this.uploadDataObjArray(newDataArray);
  }

  handleFiles(files) {
    var file = files[0];
    var reader = new FileReader();

    //檔名
    let fileName = file.name;
    //類型
    let ExtensionName = this.getFileExtension1(fileName);

    let event = new Promise((resolve, reject) => {
      reader.onload = async () => {
        switch (ExtensionName) {
          case 'srt':
            this.ProcessSRT(reader);
            break;
          case 'scc':
            this.ProcessSCC(reader);
            break;
          case 'vtt':
            this.ProcessVTT(reader);
            break;
          case 'smi':
            this.ProcessSMI(reader);
            break;
          case 'ass':
          case 'ssa':
            this.ProcessSSA(reader, ExtensionName);
            break;

          default:
            break;
        }
      };
    });
    reader.readAsText(file);
  }
  // parseSRT (data = '',videoFps) {
  //     // declare needed variables and constants
  //     const subs = []
  //     const lines = data.split(/(?:\r\n|\r|\n)/gm)
  //     let endIdx = this.lastNonEmptyLine(lines) + 1
  //     let idx = 0
  //     let time
  //     let text
  //     let sub
  //
  //     for (let i = 0; i < endIdx; i++) {
  //         sub = {}
  //         text = []
  //
  //         i = this.nextNonEmptyLine(lines, i)
  //         sub.id = parseInt(lines[i++], 10)
  //
  //         // Split on '-->' delimiter, trimming spaces as well
  //         time = lines[i++].split(/[\t ]*-->[\t ]*/)
  //
  //         //sub.start = this.toSeconds(time[0])
  //         sub.start = TimeUtils.get_Seconds_From_Timecode(time[0]);
  //
  //         // So as to trim positioning information from end
  //         idx = time[1].indexOf(' ')
  //         if (idx !== -1) {
  //             time[1] = time[1].substr(0, idx)
  //         }
  //         // sub.end = this.toSeconds(time[1])
  //         sub.end = TimeUtils.get_Seconds_From_Timecode(time[1]);
  //
  //         // Build single line of text from multi-line subtitle in file
  //         while (i < endIdx && lines[i]) {
  //             text.push(lines[i++])
  //         }
  //
  //         // Join into 1 line, SSA-style linebreaks
  //         // Strip out other SSA-style tags
  //         sub.text = text.join('\\N').replace(/\{(\\[\w]+\(?([\w\d]+,?)+\)?)+\}/gi, '')
  //
  //         // Escape HTML entities
  //         sub.text = sub.text.replace(/</g, '&lt;').replace(/>/g, '&gt;')
  //
  //         // Unescape great than and less than when it makes a valid html tag of a supported style (font, b, u, s, i)
  //         // Modified version of regex from Phil Haack's blog: http://haacked.com/archive/2004/10/25/usingregularexpressionstomatchhtml.aspx
  //         // Later modified by kev: http://kevin.deldycke.com/2007/03/ultimate-regular-expression-for-html-tag-parsing-with-php/
  //         sub.text = sub.text.replace(/&lt;(\/?(font|b|u|i|s))((\s+(\w|\w[\w\-]*\w)(\s*=\s*(?:".*?"|'.*?'|[^'">\s]+))?)+\s*|\s*)(\/?)&gt;/gi, '<$1$3$7>')
  //         sub.text = sub.text.replace(/\\N/gi, '<br />')
  //
  //         const Timecode = require('smpte-timecode');
  //         // var t = Timecode(time[0]);
  //         // t.add('00:02:30;00');
  //         // t.subtract(100); //frames
  //         // console.log(`t.frameCount == frameCount  ${t.frameCount}`);
  //         // console.log(`t.frameCount == toString  ${t.toString()}`);
  //
  //         // var minute = new Timecode('00:01:00:00');
  //         // var eightHundredFrames = new Timecode(800,23.976,false);
  //         // console.log(`t.frameCount == minute  ${minute}`);
  //         // console.log(`t.frameCount == eightHundredFrames  ${eightHundredFrames}`);
  //
  //
  //         let newDataObj = new DataObj({
  //             In: TimeUtils.getTimestringFromTimecode(time[0]),
  //             Out: TimeUtils.getTimestringFromTimecode(time[1]),
  //             InTimecode: time[0],
  //             OutTimecode: time[1],
  //             start:sub.start,
  //             end:sub.end,
  //             ShotChange:"",
  //             Duration:"",
  //             Memo:"",
  //             Source:"",
  //             SubtitleCaption:(sub.text === null || sub.text === "")?"":StringUtils.checkHTMLmark(sub.text),
  //             Length:StringUtils.getStringLength(sub.text) ,
  //             Position:""
  //         });
  //
  //
  //         subs.push(newDataObj)
  //     }
  //
  //     return subs
  // }

  lastNonEmptyLine(linesArray) {
    let idx = linesArray.length - 1;

    while (idx >= 0 && !linesArray[idx]) {
      idx--;
    }

    return idx;
  }

  nextNonEmptyLine(linesArray, position) {
    let idx = position;

    while (!linesArray[idx]) {
      idx++;
    }

    return idx;
  }

  toSeconds(time) {
    const t = time.split(':');

    try {
      let s = t[2].split(',');

      // Just in case a . is decimal seperator
      if (s.length === 1) {
        s = t[2].split('.');
      }

      return (
        parseFloat(t[0], 10) * 3600 +
        parseFloat(t[1], 10) * 60 +
        parseFloat(s[0], 10) +
        parseFloat(s[1], 10) / 1000
      );
    } catch (e) {
      return 0;
    }
  }

  async handleSourceFiles(files) {
    var file = files[0];
    var reader = new FileReader();

    let event = new Promise((resolve, reject) => {
      reader.onload = async () => {
        //確認資料index 跟專案資料
        let projectIndex = parseInt(this.props.match.params.tIndex, 10);
        const projectListDataString = localStorage.getItem('projectListData');
        //取得本地資料
        const projectListData = JSON.parse(projectListDataString);
        const projectData = projectListData[projectIndex];
        const projectDetial = projectData.projectDetial;

        //儲存到本地
        //新增
        const { user } = this.props.auth;
        const email = user['email'];

        //新增
        // await this.props.AddDetialJsonData({
        //     "tProjectDetialId":projectDetial.fId,
        //     "jsonstring":reader.result,
        //     "email":email
        // });

        console.log(reader.result);

        //新增
        const jsonData = await ApiUtils.post_sql(
          `${ApiUtils.post_AddDetialJsonData_email}`,
          {
            tProjectDetialId: projectDetial.fId,
            jsonstring: JSON.stringify(
              StringUtils.ZipUploadFile(JSON.parse(reader.result))
            ),
            email: email,
          }
        );

        ApiUtils.checkSaveIsSuccess(jsonData);

        window.location.reload();
      };
    });
    reader.readAsText(file);
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  render() {
    let ReactFileReaderView;
    if (this.state.jsonSubs === '') {
      ReactFileReaderView = (
        <ReactFileReader
          fileTypes={['.srt', '.txt', '.scc']}
          multipleFiles={false}
          handleFiles={this.handleFiles}
        >
          <Button variant='info'>Upload file</Button>
        </ReactFileReader>
      );
    }

    let okButton;
    if (this.state.jsonSubs !== '') {
      okButton = (
        <Button
          variant='success'
          onClick={() => {
            this.props.closeImportView();
          }}
        >
          Ok
        </Button>
      );
    }

    return (
      <div>
        <Divider horizontal>
          <Header as='h4'>
            <Icon name='file alternate outline' />
            File Reader
          </Header>
        </Divider>

        <Grid columns={3} divided className={'px-5'}>
          <Grid.Row>
            <Grid.Column>
              <ReactFileReader
                fileTypes={[
                  '.srt',
                  '.txt',
                  '.scc',
                  '.vtt',
                  '.smi',
                  '.ssa',
                  '.ass',
                ]}
                multipleFiles={false}
                handleFiles={this.handleFiles}
              >
                <Button variant='info'>Upload file</Button>
              </ReactFileReader>

              <small>.txt .srt .scc .vtt .smi　.ssa .ass</small>
            </Grid.Column>

            <Grid.Column>
              <ReactFileReader
                fileTypes={['.xml']}
                multipleFiles={false}
                handleFiles={this.handleFiles_flash_xml}
              >
                <Button variant='info'>Upload XML</Button>
              </ReactFileReader>

              <small>Flash XML (.xml)</small>
            </Grid.Column>

            <Grid.Column>
              <ReactFileReader
                fileTypes={['.xml']}
                multipleFiles={false}
                handleFiles={(files) => {
                  var file = files[0];
                  var reader = new FileReader();

                  let event = new Promise((resolve, reject) => {
                    reader.onload = async () => {
                      this.ProcessXML_Time(reader);
                    };
                  });
                  reader.readAsText(file);
                }}
              >
                <Button variant='info'>Upload XML</Button>
              </ReactFileReader>
              <small>Time XML (.xml)</small>
            </Grid.Column>

            <Grid.Column>
              <ReactFileReader
                fileTypes={['.ttml']}
                multipleFiles={false}
                handleFiles={(files) => {
                  var file = files[0];
                  var reader = new FileReader();

                  let event = new Promise((resolve, reject) => {
                    reader.onload = async () => {
                      this.ProcessTTML_Time(reader);
                    };
                  });
                  reader.readAsText(file);
                }}
              >
                <Button variant='info'>Upload TTML</Button>
              </ReactFileReader>
              <small>TTML (.ttml)</small>
            </Grid.Column>
            <Grid.Column>
              <ReactFileReader
                fileTypes={['.dfxp']}
                multipleFiles={false}
                handleFiles={(files) => {
                  var file = files[0];
                  var reader = new FileReader();

                  let event = new Promise((resolve, reject) => {
                    reader.onload = async () => {
                      this.ProcessDFXP(reader);
                    };
                  });
                  reader.readAsText(file);
                }}
              >
                <Button variant='info'>Upload dfxp</Button>
              </ReactFileReader>
              <small>.dfxp</small>
            </Grid.Column>

            <Grid.Column>
              <ReactFileReader
                fileTypes={['.sub']}
                multipleFiles={false}
                handleFiles={this.handleFiles_MicroDVD}
              >
                <Button variant='info'>MicroDVD SUB</Button>
              </ReactFileReader>
              <small>.sub</small>
            </Grid.Column>

            <Grid.Column>
              <ReactFileReader
                fileTypes={['.sbv']}
                multipleFiles={false}
                handleFiles={(files) => {
                  var file = files[0];
                  var reader = new FileReader();
                  let event = new Promise((resolve, reject) => {
                    reader.onload = async () => {
                      this.ProcessSubViewer(reader);
                    };
                  });
                  reader.readAsText(file);
                }}
              >
                <Button variant='info'>SubViewer</Button>
              </ReactFileReader>
              <small>.sbv</small>
            </Grid.Column>

            {/*<Grid.Column>*/}
            {/*    <ReactFileReader fileTypes={[".cap"]} multipleFiles={false} handleFiles={(files)=>{*/}
            {/*        var file = files[0];*/}
            {/*        var reader = new FileReader();*/}
            {/*        let event = new Promise((resolve, reject) => {*/}
            {/*            reader.onload = async () => {*/}
            {/*                this.ProcessCap(reader);*/}
            {/*            };*/}
            {/*        });*/}
            {/*        reader.readAsText(file);*/}
            {/*    }}>*/}
            {/*        <Button variant="info">Wise Infinity (.cap)</Button>*/}
            {/*    </ReactFileReader>*/}
            {/*    <small>*/}
            {/*        .cap*/}
            {/*    </small>*/}
            {/*</Grid.Column>*/}

            {/*<Grid.Column>*/}
            {/*    <ReactFileReader fileTypes={[".qt",".txt"]} multipleFiles={false} handleFiles={(files)=>{*/}
            {/*        var file = files[0];*/}
            {/*        var reader = new FileReader();*/}
            {/*        let event = new Promise((resolve, reject) => {*/}
            {/*            reader.onload = async () => {*/}
            {/*                this.ProcessQT(reader);*/}
            {/*            };*/}
            {/*        });*/}
            {/*        reader.readAsText(file);*/}
            {/*    }}>*/}
            {/*        <Button variant="info">Quick Time Text</Button>*/}
            {/*    </ReactFileReader>*/}
            {/*    <small>*/}
            {/*        .qt .txt*/}
            {/*    </small>*/}
            {/*</Grid.Column>*/}
          </Grid.Row>
        </Grid>

        <Divider horizontal>
          <Header as='h4'>
            <Icon name='file alternate' />
            Source Reader
          </Header>
        </Divider>

        {this.state.jsonSubs === '' ? (
          <ReactFileReader
            fileTypes={['.srt', '.txt']}
            multipleFiles={false}
            handleFiles={this.handleSourceFiles}
          >
            <Button variant='secondary'>Upload Source</Button>
          </ReactFileReader>
        ) : (
          <Button
            variant='success'
            onClick={() => {
              this.props.closeImportView();
            }}
          >
            Ok
          </Button>
        )}

        {/*{this.state.jsonSubs}*/}
      </div>
    );
  }
}

ImportView.propTypes = {
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  transOperation: state.transOperation,
  findOperation: state.findOperation,
  project: state.project,
});

export default connect(mapStateToProps, {
  AddDetialJsonData,
  addTenRow,
  setVideoFPS,
  setTableData,
  setPlayerEditingSRTData,
  copyToSource,
})(withRouter(ImportView));



// WEBPACK FOOTER //
// ./src/components/import/ImportView.js